import React, { useState, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Phone, Mail, MapPin } from 'lucide-react';
import emailjs from '@emailjs/browser';

export function ContactPage() {
  const { t } = useLanguage();
  const [formStatus, setFormStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('sending');
    
    try {
      await emailjs.sendForm(
        'service_jo42glq', // EmailJS service ID'nizi buraya ekleyin
        'template_v0myj89', // EmailJS template ID'nizi buraya ekleyin
        formRef.current!,
        'gJnP52gURMFjR-60_' // EmailJS public key'inizi buraya ekleyin
      );
      
      setFormStatus('success');
      if (formRef.current) {
        formRef.current.reset();
      }
    } catch (error) {
      console.error('Failed to send email:', error);
      setFormStatus('error');
    }
  };

  return (
    <div className="bg-gray-50">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-lg mx-auto md:max-w-none md:grid md:grid-cols-2 md:gap-8">
          <div>
            <h1 className="text-3xl font-extrabold text-gray-900">
              {t('contact.title')}
            </h1>
            <p className="mt-3 text-lg text-gray-600">
              {t('contact.subtitle')}
            </p>

            <div className="mt-8 space-y-6">
              <div className="flex items-center">
                <Phone className="h-6 w-6 text-blue-900" />
                <span className="ml-3 text-gray-600">+49 (0) 40 37 6129 52</span>
              </div>
              <div className="flex items-center">
                <Mail className="h-6 w-6 text-blue-900" />
                <span className="ml-3 text-gray-600">info@asena-ug.de</span>
              </div>
              <div className="flex items-center">
                <MapPin className="h-6 w-6 text-blue-900" />
                <span className="ml-3 text-gray-600">Holzmühlenstraße 33 <br /> 21043, Hamburg, Germany</span>
              </div>
            </div>
          </div>

          <div className="mt-12 sm:mt-16 md:mt-0">
            <form ref={formRef} onSubmit={handleSubmit} className="grid grid-cols-1 gap-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  {t('contact.form.name')}
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-900 focus:ring-blue-900"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  {t('contact.form.email')}
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-900 focus:ring-blue-900"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                  {t('contact.form.message')}
                </label>
                <textarea
                  name="message"
                  id="message"
                  rows={4}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-900 focus:ring-blue-900"
                />
              </div>
              <div>
                <button
                  type="submit"
                  disabled={formStatus === 'sending'}
                  className="w-full inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-blue-900 hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-900"
                >
                  {formStatus === 'sending' ? t('contact.form.sending') : t('contact.form.submit')}
                </button>
                {formStatus === 'success' && (
                  <p className="mt-2 text-sm text-green-600">
                    {t('contact.form.success')}
                  </p>
                )}
                {formStatus === 'error' && (
                  <p className="mt-2 text-sm text-red-600">
                    {t('contact.form.error')}
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}